import PropTypes from "prop-types"
import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { t } from "../../i18next"
import { PageNotFound } from "../common"
import * as actions from "./redux/actions"
import { ACCOUNTING_HINT_CODES_BY_LEVEL, DAMAGE_TYPES, DamageCaseIdShape, FeatureStateShape } from "./redux/shapes"
import { DamageCasePage, DamageCasePageHeader, DamageCaseNavigation } from "."

export class RemdataPage extends Component {
  static propTypes = {
    damageCase: FeatureStateShape.isRequired,
    actions: PropTypes.object.isRequired,
    caseId: DamageCaseIdShape.isRequired,
  }

  render() {
    const { caseId } = this.props
    const { unsentCases } = this.props.damageCase
    const currentCase = unsentCases[caseId]

    if (currentCase) {
      return this.renderCase(currentCase)
    } else {
      return <PageNotFound />
    }
  }

  renderCase(currentCase) {
    const { caseId } = this.props
    const { lhoRef, capOnExpenses, damageType, accountingHintCode, passingCosts } = currentCase
    const lhoLevel = ["property", "house", "unit"][lhoRef.split(".").length - 1]

    const submitCasePending = Boolean(this.props.damageCase.submitCasePending.find(id => id === caseId))
    const submitCaseError = this.props.damageCase.submitCaseError[caseId]
    const dismissSubmitCaseError = () => this.props.actions.dismissSubmitCaseError(caseId)

    return (
      <DamageCasePage
        className="damage-case-remdata-page"
        submitPending={submitCasePending}
        submitError={submitCaseError}
        dismissSubmitCaseError={dismissSubmitCaseError}
      >
        <DamageCasePageHeader caseId={caseId} />
        <div className="app-content">
          <DamageCaseNavigation className="app-content_left" caseId={caseId} currentPage="remdata" />

          <div className="app-content_middle">
            {DamageTypeInput({
              initialValue: damageType,
              toggleValue: this.toggleSingleValue("damageType", damageType),
            })}
            {CapOnExpensesInput({ initialValue: capOnExpenses, rememberValue: this.rememberValue("capOnExpenses") })}
          </div>

          <div className="app-content_middle">
            {AccountingHintInput({
              initialValue: accountingHintCode,
              toggleValue: this.toggleSingleValue("accountingHintCode", accountingHintCode),
              lhoLevel,
            })}
            {PassingCostsInput({
              initialValue: passingCosts,
              toggleValue: this.toggleSingleValue("passingCosts", passingCosts),
            })}
          </div>
        </div>
      </DamageCasePage>
    )
  }

  rememberValue = key => value => this.props.actions.rememberAttribute(this.props.caseId, key, value)
  toggleSingleValue = (key, currentValue) => value => this.rememberValue(key)(value !== currentValue ? value : null)
}

const DamageTypeInput = ({ initialValue, toggleValue }) => (
  <div>
    <h2>{t("damageCase.damageType")}</h2>
    <div className="damage-type chewbacca">
      {DAMAGE_TYPES.map(val => (
        <button key={val} className={`item ${initialValue === val ? "selected" : ""}`} onClick={() => toggleValue(val)}>
          {t(`damageCase.damageTypes.${val}`)}
          <div className="description">{t(`damageCase.damageTypeHints.${val}`)}</div>
        </button>
      ))}
    </div>
  </div>
)

const CAP_MIN = 100
const CAP_MAX = 1000
const CAP_STEP = 100
const CapOnExpensesInput = ({ initialValue, rememberValue }) => (
  <div>
    <h2>{t("damageCase.capOnExpenses")}</h2>
    <div className="cap-on-expenses chewbacca">
      <input
        type="range"
        min={CAP_MIN}
        max={CAP_MAX}
        step={CAP_STEP}
        value={initialValue}
        onChange={ev => rememberValue(Number(ev.target.value))}
      />

      <input
        id="cap-on-expenses"
        type="number"
        min={0}
        step={CAP_STEP}
        value={initialValue}
        onChange={ev => rememberValue(Number(ev.target.value))}
      />
    </div>
  </div>
)

const AccountingHintInput = ({ lhoLevel, initialValue, toggleValue }) => (
  <div>
    <h2>{t("damageCase.accountingHint")}</h2>
    <div className="accounting-hint chewbacca">
      {ACCOUNTING_HINT_CODES_BY_LEVEL[lhoLevel].map(val => (
        <button key={val} className={`item ${initialValue === val ? "selected" : ""}`} onClick={() => toggleValue(val)}>
          {t(`damageCase.accountingHintCodes.${val}`)}
        </button>
      ))}
    </div>
  </div>
)

const PassingCostsInput = ({ initialValue, toggleValue }) => (
  <div>
    <h2>{t("damageCase.passingCosts")}</h2>
    <div className="cost-transfer chewbacca">
      <button className={`item ${initialValue === true ? "selected" : ""}`} onClick={() => toggleValue(true)}>
        {t("common.yes")}
      </button>

      <button className={`item ${initialValue === false ? "selected" : ""}`} onClick={() => toggleValue(false)}>
        {t("common.no")}
      </button>
    </div>
  </div>
)

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  const { caseId } = ownProps.match.params

  return {
    damageCase: state.damageCase,
    caseId,
  }
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemdataPage)



// WEBPACK FOOTER //
// ./src/features/damage-case/RemdataPage.js